import { Component, Input } from '@angular/core';
import { FxRateService } from '@univacity/angular/datas';
import { INTERVAL } from '@univacity/shared/types';
import { IconType } from '../../interfaces';
import { ScreenSizeService } from '../../services';

@Component({
  selector: 'un-cost-widget',
  templateUrl: './cost-widget.component.html',
  styleUrls: ['./cost-widget.component.less'],
  standalone: false,
})
export class CostWidgetComponent {
  @Input() amount?: number;
  @Input() min?: number;
  @Input() max?: number;
  @Input() currency: string;
  @Input() unTitle = '';
  @Input() interval?: INTERVAL;
  @Input() icon?: string;
  @Input() iconTheme?: IconType;

  constructor(public screenSize: ScreenSizeService, public fx: FxRateService) {}
}
